// v3-style imperative navigation for class components (replaces react-router's browserHistory).
// The router instance is registered by createAppRouter to avoid an import cycle.
let router = null;

export function setRouter(r) {
  router = r;
}

export const browserHistory = {
  push: (path) => router.navigate(path),
  replace: (path) => router.navigate(path, { replace: true })
};
